import Box from "ds/components/Box";
import { isRunReviewable } from "shared/Run/useReviewRun/accessValidation";
import {
  ExclamationMarkCircleFilled,
  ExclamationMarkTriangleFilled,
} from "components/icons/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import useElementWidth from "hooks/useElementWidth";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import StackListItemIssuesCellItem from "./Item";

const CELL_COMPACT_WIDTH = 115;

const StacksTableIssuesCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const stackRunNeedsApproval = isRunReviewable(stack.blocker);

  const [containerRef, containerWidth] = useElementWidth<HTMLDivElement>();

  const isCompact = containerWidth < CELL_COMPACT_WIDTH;

  return (
    <TableSimpleCell {...cellProps}>
      <Box
        ref={containerRef}
        direction={isCompact ? "row" : "column"}
        gap="medium"
        align="start"
        fullWidth
      >
        {stack.isDrifted && (
          <StackListItemIssuesCellItem
            iconColor="danger"
            icon={ExclamationMarkCircleFilled}
            hideText={isCompact}
          >
            Drift detected
          </StackListItemIssuesCellItem>
        )}

        {stackRunNeedsApproval && (
          <StackListItemIssuesCellItem
            iconColor="warning"
            icon={ExclamationMarkTriangleFilled}
            hideText={isCompact}
          >
            Needs approval
          </StackListItemIssuesCellItem>
        )}

        {!stack.isDrifted && !stackRunNeedsApproval && <TableCellEmpty />}
      </Box>
    </TableSimpleCell>
  );
};

export default StacksTableIssuesCell;
